import React from 'react';

/**
 * Critical CSS component for above-the-fold content
 * Helps improve LCP by inlining critical styles
 */
const CriticalCSS = () => (
  <style dangerouslySetInnerHTML={{
    __html: `
      /* Critical CSS for above-the-fold content */
      .booking-header h1 {
        font-family: 'Cinzel', serif !important;
        font-weight: 700 !important;
        line-height: 1.2 !important;
        letter-spacing: 0.025em !important;
        color: #D4AF37 !important;
        font-size: 2.5rem !important;
      }
      
      @media (min-width: 768px) {
        .booking-header h1 {
          font-size: 3rem !important;
        }
      }
      
      .booking-header p {
        font-family: 'Montserrat', sans-serif !important;
        font-weight: 400 !important;
        line-height: 1.6 !important;
        color: #d1d5db !important;
        font-size: 1.125rem !important;
      }
      
      /* Prevent layout shift */
      .booking-container {
        min-height: 100vh;
        display: flex;
        flex-direction: column;
      }
      
      /* Optimize font loading */
      @font-face {
        font-family: 'Cinzel';
        font-display: swap;
        font-weight: 400 700;
      }
      
      @font-face {
        font-family: 'Montserrat';
        font-display: swap;
        font-weight: 400 500 700;
      }
    `
  }} />
);

export default CriticalCSS;